import { render, staticRenderFns } from "./rlvEvidence.vue?vue&type=template&id=6674ba58"
import script from "./rlvEvidence.vue?vue&type=script&lang=js"
export * from "./rlvEvidence.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports